import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './Production.css';

const accordionData = [
  {
    id: 1,
    title: 'Проектирование',
    content: 'Разрабатываем 3D-модели и полный пакет конструкторской документации. Работаем с любыми формами: от простых распределительных коробок до сложных пультов и шкафов с климат-контролем.'
  },
  {
    id: 2,
    title: 'Изготовление',
    content: 'Все этапы металлообработки — на собственном оборудовании . Мы не передаём заказы на субподряд, поэтому контролируем качество на каждом шаге.'
  },
  {
    id: 3,
    title: 'Сборка, контроль качества, упаковка, отгрузка',
    content: 'На финальном этапе мы собираем шкаф, монтируем оборудование, проверяем каждый узел и готовим продукт к отправке клиенту.'
  },
  {
    id: 4,
    title: 'Что мы умеем',
    content: 'Работаем с нержавеющей сталью AISI 304/316 и углеродистой сталью толщиной от 1,2 до 4 мм. Обеспечиваем степень защиты IP55–IP66, порошковую окраску в любой цвет RAL и полный пакет документации (паспорта, сертификаты, протоколы испытаний). Изготавливаем корпуса по чертежам заказчика от 1 штуки до серии.'
  }
];

const Production = () => {
  const [openAccordion, setOpenAccordion] = useState(1);

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  return (
    <section id="production" className="production">
      <div className="container-custom">
        <div className="production-grid">
          <div className="production-content">
            <h2 className="production-title">Производство полного цикла</h2>
            <p className="production-desc">
              Собственное конструкторское бюро, лазерная резка, гибка, сварка, окраска, сборка и контроль качества — всё на одной площадке. Работаем с нержавеющей AISI 304/316 и углеродистой сталью. Полное импортозамещение.
            </p>
            <p className="production-desc">
              Все это позволяет нам изготавливать шкафы из нержавеющей стали любой сложности от 1 штуки до серии.
            </p>
            
            <div className="prod-accordion">
              {accordionData.map((item) => (
                <div key={item.id} className={`prod-accordion-item ${openAccordion === item.id ? 'active' : ''}`}>
                  <button
                    className="prod-accordion-header"
                    onClick={() => toggleAccordion(item.id)}
                  >
                    <span className="prod-accordion-title">{item.title}</span>
                    {openAccordion === item.id ? <FaChevronUp /> : <FaChevronDown />}
                  </button>
                  <div className="prod-accordion-body">
                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="production-image">
            <img src="/images/production.webp" alt="Изготовление корпусов из стали" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Production;
